import { gql } from '@apollo/client';

export const HUB_ASSIGNED_TASKS = gql`
  query HubAssignedTasks($hubId: Long!, $dayRange: Int) {
    hubAssignedTasks(hubId: $hubId, dayRange: $dayRange) {
      tasks {
        taskId
        warehouseId
        warehouseName
        warehouseTimeZone
        title
        detail
        priority
        assignedAt
        dueAt
        status
        isOverdue
        overdueMinutes
        progressText
        completedAt
        requirePhotoProof
        canCancel
      }
      recentTitles
      totalInRange
    }
  }
`;
